export default ['reason', 'status'];
